import { render, staticRenderFns } from "./LastEdited.vue?vue&type=template&id=161187a0&"
import script from "./LastEdited.vue?vue&type=script&lang=js&"
export * from "./LastEdited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports